module.exports = __webpack_public_path__ + "static/media/video.efbba978.jpg";